import React from 'react';

const ProductCard = ({ data }) => {
    const { price, img, name } = data;
    return (
        <div className="col-lg-3 col-md-6">
            <div className="product_item">
                <div className="product_imagebox">
                    <img className="primary_img" src={img} alt="img" />
                    <div className="product_item_inner">
                        <div className="button_group">
                            <a href="#" className="button">Add to Cart</a>
                        </div>
                    </div>
                </div>
                <div className="label_text">
                    <h5 className="product_item_name"><a href="/single-product">{name}</a></h5>
                    <div className="rating">
                        <ul>
                            <li><i className="ion-ios-star"></i></li>
                            <li><i className="ion-ios-star"></i></li>
                            <li><i className="ion-ios-star"></i></li>
                            <li><i className="ion-ios-star-half"></i></li>
                            <li><i className="ion-ios-star-outline"></i></li>
                        </ul>
                    </div>
                    <h6 className="product_item_price">{price}</h6>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;